import { NULL_FUNCTION } from "./common";

export const isIE11 = !!window["MSInputMethodContext"] && !!document["documentMode"];

const entryPoint = "krypton";
const kryptonNamespace = 'window["' + entryPoint + '"]';
const moduleNamespace = kryptonNamespace + '["module"][${module}]';
const pageNamespace = moduleNamespace + '["page"][${page}]';
const moduleTemplate = kryptonNamespace + '=' + kryptonNamespace + ' || { module: { } };' + moduleNamespace + ' = ' + moduleNamespace + ' || { }; window["m"] =  window["m"] || ' + kryptonNamespace + '["module"];';
const pageTemplate = moduleTemplate + moduleNamespace + '["page"] = ' + moduleNamespace + '["page"] || {};' + pageNamespace + ' = ' + pageNamespace + '|| {};';

export function localizeScript(script: HTMLScriptElement): HTMLScriptElement | void {
    if (!script)
        return;
    const result = document.createElement("script");
    result.textContent = "(function () {" + script.textContent + " })()";
    return result;
}

export function scripter(script: HTMLScriptElement): HTMLScriptElement | void {

    if (!script)
        return;

    const module = script.hasAttribute("module") ? script.getAttribute("module") : null
        , page = script.hasAttribute("page") ? script.getAttribute("page") : null
        , template = page ? pageTemplate : moduleTemplate;

    let templateJS = template.replace(/\${module}/g, '"' + module + '"').replace(/\${page}/g, '"' + page + '"');
    let scriptJS = script.textContent?.replace(/__\./g, pageNamespace.replace(/\${module}/g, '"' + module + '"').replace(/\${page}/g, '"' + page + '"') + '.').replace(/_\./g, moduleNamespace.replace(/\${module}/g, '"' + module + '"') + '.');

    const result = document.createElement("script");
    result.textContent = templateJS + scriptJS;
    if (module) result.setAttribute("module", module);
    if (page) result.setAttribute("page", page);
    if (script.getAttribute("type") == "module") result.setAttribute("type", "module");
    return result;
}

/**
 * Clears page level namespace for memory optimization
 *
 * @param script
 */
export function unscripter(script: HTMLScriptElement): void {
    if (!script)
        return;
    const moduleName = script.getAttribute("module");
    const moduleNamespace = window[entryPoint]["module"][moduleName];
    const page = script.getAttribute("page");
    if (moduleNamespace && page) {
        delete moduleNamespace["page"][page];
    }
}

const FUNCTION_TYPE_REGEX = /^(\s*\(?\s*function)|(\([a-zA-Z0-9_\-, ]*\)\s*=>)|([a-zA-Z0-9_\-]\s*=>)|([a-zA-Z0-9_\-.]*\w+$)/i;
const LAMBDA_REGEX = /^\([a-zA-Z0-9_\-, ]*\)\s*=>|[a-zA-Z0-9_\-]\s*=>/mi;
const FUNCTION_REGEX = /^function\s*\(([^()]*)\)[ \n\t]*{(.*)}/mi;
const NAMESPACE_REGEX = /^[a-zA-Z0-9_\-.]*\w+$/;

type FUNCTION_TYPE = "unknown" | "function" | "lambda" | "single-lambda" | "reference";

function getFunctionType(functionAsString: string): FUNCTION_TYPE {
    const funcTypeMatch = FUNCTION_TYPE_REGEX.exec(functionAsString);
    if (!funcTypeMatch)
        return "unknown"
    if (funcTypeMatch[1])
        return "function";
    if (funcTypeMatch[2])
        return "lambda";
    if (funcTypeMatch[3])
        return "single-lambda"
    if (funcTypeMatch[4])
        return "reference"
    return "unknown";
}

//TODO attemppt to check function body for malicious code? any savvy person can get around client side javascript, this may not be useful and just add overhead
function verifyFunctionBody(body: string): boolean {
    return !/location\.|history\.push|fetch\s*\(|\$\.ajax|XMLHttpRequest/igm.test(body);
}

export function parseFunction(functionAsString: string): Function {

    const functionType: FUNCTION_TYPE = getFunctionType(functionAsString);

    switch (functionType) {
        case "reference": {
            let part: string | undefined,
                parts: string[] = functionAsString.split("."),
                obj: object = globalThis;
            return () => {
                while (part = parts.shift()) obj = obj[part];
                if (typeof obj == "function") obj();
            };
        }
        case "function": {
            let functionMatch = FUNCTION_REGEX.exec(functionAsString.replace(/\n/g, ' '));
            if (functionMatch) {
                let params = functionMatch[1].split(','),
                    body = functionMatch[2];
                return new Function(...params.concat(body));
            }
            return NULL_FUNCTION;
        }
        case "lambda": {
            let parts = functionAsString.split("=>")
                , params = parts[0].trim().replace(/\(|\)/g, "").split(",")
                , body = parts[1].trim();
            return new Function(...params.concat(body));
        }
        case "single-lambda": {
            let parts = functionAsString.split("=>")
                , params = parts[0].trim()
                , body = parts[1].trim();
            return new Function(params, body);
        }
        case "unknown":
        default:
            return NULL_FUNCTION;
    }

}